// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue'
import App from './App'
import Router from 'vue-router'
import routes from './router'
import store from './store/index';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/style.css';
import Public from './common/Public';

import cookie from 'vue-cookie';

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.use(Router);
Vue.use(Public);
//let router = new Router(paths);
let router = new Router({
    routes
});
//访问任一页面前要检测是否已登录和登录token的有效性
router.beforeEach((to,from,next)=>{
    if(to.path === '/login'){
        return next();
    }
    //从url内取token,有，则存入cookie，视为已登录
    let sc1 = to.query.sc1;
    console.log(to);
    console.log(sc1);
    if(sc1){
        cookie.set('sc1',unescape(sc1));
    }

    let token = cookie.get('sc1');
    if(token){
        let store = router.app.$store;
        let userinfo = store.state.system.userinfo;
        if(!userinfo){
            router.app.$showLoading();
            store.dispatch('getUserInfo',{self:router.app,cb:(msg)=>{
                    router.app.$closeLoading();
                    if(msg.result === 0){
                        return next();
                    }else{
                        //return next({path:'/login'});
                        //window.location.replace('/');
                    }
                }})
        }else{
            return next();
        }
    }else{
        //window.location.replace('/');
    }
});
new Vue({
	el: '#app',
	router,
	store,
	components: { App },
	template: '<App/>'
});


// WEBPACK FOOTER //
// ./src/main.js